import React from "react";
import { Button } from "@jauntin/react-ui";

const ButtonCollapse = ({
  clickFunction,
  showList,
  title,
}: {
  clickFunction: () => void;
  showList: boolean;
  title: string;
}) => {
  return (
    <Button
      className="btn-link p-0 font-weight-bold text-left mr-5 d-flex align-items-center"
      onClick={clickFunction}
      text={
        <>
          {showList ? (
            <i className="fa fa-solid fa-chevron-up mr-2" />
          ) : (
            <i className="fa fa-solid fa-chevron-down mr-2" />
          )}{" "}
          <span>{title}</span>
        </>
      }
    />
  );
};

export default ButtonCollapse;
